<script>
    import { onMount } from "svelte";
    import ManualInput from "./manual-input.svelte";
    import SuggestionInput from "./suggestion-input.svelte";
    import Tabs from "../../../reusable-components/tabs.svelte";
    import { keyphrases, competitorUrls, show_sidebar, active_breadcrumb } from "../../../app-store";
	import { navigate } from "svelte-routing";

    export let params;

    let keyphrases_mode = "keyphrases-mode-suggestion";

    const tab_options = [
        {
            id: "keyphrases-mode-manual",
            label: "Enter keywords manually",
        },
        {
            id: "keyphrases-mode-suggestion",
            label: "Select from suggestions",
        },
    ];
    const default_tab_options_index = 1;

    const handleTabChange = (selectedId) => {
        keyphrases_mode = selectedId;
    };

    const draftSubmit = () => {
        const validKeyphrases = $keyphrases.filter((item) => item.status === "valid");
        if (validKeyphrases.length === 0) {
            app.toast_msg.show("Please provide at least one valid keyphrase and URL");
            return;
        }
        console.log("Draft submitted with the following keyphrases:");
        console.table($keyphrases);

        const keyphrasesTuple = validKeyphrases.map((item) => {
            return [item.keyword, item.urlref];
        });

        navigate(`/article-list-loader/${params.project_ref}/${params.draft_refcode}`, {
            state: {
                keyphrase_url_tuple: keyphrasesTuple,
            },
        });
    };

    onMount(() => {
        app.body_spinner.remove();
        show_sidebar.set(true);
        active_breadcrumb.set("breadcrumb-project"); // TODO: set this as new draft breadcrumb

        app.chat_manager.clear();
        app.chat_manager.hide();

        handleTabChange(tab_options[default_tab_options_index].id);
    });
</script>

<div class="app-screen new-draft new-draft-screen">
    <div id="new-draft" class="action-area new-draft">
        <div class="article-creation">
            <div class="action-area new-draft-container d-flex align-items-center justify-content-between flex-wrap">
                <div>
                    <div class="h5 action-area-title fw-bold">Start Your Article Creation</div>
                    <p class="action-area-subtitle form-card-desc text-muted">
                        Provide the necessary details to begin crafting your optimized article.
                    </p>
                </div>
                <Tabs
                    classname="keyphrases-mode-switch"
                    options={tab_options}
                    selectedOption={tab_options[default_tab_options_index].id}
                    onOptionChange={handleTabChange}
                />
            </div>
        </div>
        {#if keyphrases_mode === "keyphrases-mode-manual"}
            <ManualInput {params} draftSubtmit={draftSubmit} />
        {:else}
            <SuggestionInput {params} {draftSubmit} show={keyphrases_mode === "keyphrases-mode-suggestion"} />
        {/if}
    </div>
</div>
